module.exports = __webpack_public_path__ + "static/7th-61b52c69b7f318505aa393bb5c5b4b42.png";